import React from 'react';
import { Button, PageContainer } from '../../../components/common';
import { CreditCard, Banknote, X } from 'lucide-react';
import './payment.css';
import { ELEMENT_IDS } from '../../../constants/ids';

function PaymentNode() {
  const METHODS = [
    { id: 'credit', label: 'Credit Card', Icon: CreditCard },
    { id: 'echeck', label: 'eCheck', Icon: Banknote },
  ];

  return (
    <PageContainer className="paymentNode-Container">
      <div className="paymentNode-header-container">
        <h2>Select Payment Method</h2>
        <p>
          To enjoy uninterrupted high-speed internet, select your convenient
          payment option below.
        </p>
      </div>

      <div className="paymentNode-formCard">
        <h3 className="paymentNode-cardTitle">Select Payment Method</h3>

        <div className="paymentNode-options">
          {METHODS.map(({ id, label, Icon }) => (
            <div key={id} id={`payment-${id}`} className="paymentNode-option">
              <span>{label}</span>
              <Icon className="paymentNode-option__icon" />
            </div>
          ))}
        </div>
      </div>

      <div id="payment-modal" className="paymentNode-modal hidden">
        <div className="paymentNode-modalContent">
          <button className="paymentNode-modalClose" aria-label="Close">
            <X size={20} />
          </button>
          <div className="paymentNode-modalIframeWrapper"></div>
        </div>
      </div>

      <div className="paymentNode-buttonRow">
        <Button
          customId={ELEMENT_IDS.SKIP_BUTTON}
          label="Skip Payment"
        />
        <Button
          customId={ELEMENT_IDS.NEXT_STEP_BUTTON}
          label="Confirm and Make Payment"
          right={<span className="paymentNode-psnArrow">→</span>}
        />
      </div>
    </PageContainer>
  );
}

export default PaymentNode;
